
















































import { Component, Vue } from "vue-property-decorator";
import AppHeader from "./AppHeader.vue";
import ErrorAlert from "@/components/ErrorAlert.vue";
import IconLogo from "@/components/IconLogo.vue";

@Component({
  components: {
    AppHeader,
    ErrorAlert,
    IconLogo
  }
})
export default class SignInPage extends Vue {
  params = {
    email: "",
    password: ""
  };

  errors: string[] = [];

  // 元々アクセスしようとしていたページ
  get destination(): string {
    if (this.$route.query.destination) {
      return this.$route.query.destination as string;
    } else {
      return "/";
    }
  }

  async signIn() {
    try {
      await this.$store.dispatch("signIn", this.params);
    } catch (e) {
      this.errors = e;
      return;
    }
    this.$router.push(this.destination);
  }
}
